import { Box as MuiBox } from '@material-ui/core';

export const Box = MuiBox;
